import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import { resolveSettingsParentPath } from "./legacySettingsRedirects";

export const useNavigateSettingsParent = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return useCallback(() => {
        navigate(resolveSettingsParentPath(pathname));
    }, [navigate, pathname]);
};
